import { useEffect } from 'react'

import { resolveSyncedHistoryVersion } from '@/pages/User/pages/Home/components/Preview/previewHistoryUtils'

import { useDetailTabContext } from '../context/DetailTabContext'
import { ActionTypeEnum } from '../context/types'

type UseSyncHistoryToDetailTabParams = {
	historyActive: boolean
	selectedVersion: number
	versionMax: number
}

/** Publishes V2 header history controls into DetailTabContext (legacy pages use ViewHistory instead). */
export const useSyncHistoryToDetailTab = ({
	historyActive,
	selectedVersion,
	versionMax,
}: UseSyncHistoryToDetailTabParams) => {
	const {
		state: { editModeProp },
		dispatch,
	} = useDetailTabContext()

	const historyVersion = resolveSyncedHistoryVersion(
		historyActive,
		selectedVersion,
		versionMax,
	)

	useEffect(() => {
		dispatch({
			type: ActionTypeEnum.DETAIL_TAB_UPDATE,
			update: {
				versionActive: historyActive,
				versionMax,
				version: historyVersion,
				editMode: historyVersion ? false : editModeProp,
			},
		})
	}, [dispatch, editModeProp, historyActive, historyVersion, versionMax])
}
